export default __webpack_public_path__ + "static/media/slide1.04ddf403.jpg";